import { Reducer } from "redux";

import { SSO_ActionDispatchTypes } from "../constants/Sso";
import { SSO_ActionTypes } from "../models/DispatchTypes/Sso";
import { ExchangedTokenResponse } from "../models/Api/Sso";

const initialState: ExchangedTokenResponse = {
  loading: false,
  response: null,
  error: null,
};

const ExchangedTokenReducer: Reducer<
  ExchangedTokenResponse,
  SSO_ActionTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case SSO_ActionDispatchTypes.SSO_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case SSO_ActionDispatchTypes.SSO_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case SSO_ActionDispatchTypes.SSO_ERROR: {
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    }
    case SSO_ActionDispatchTypes.SSO_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ExchangedTokenReducer;
